objOrIdOrRef